import { useEffect, useState } from 'react';

const useCountdown = (targetDate: Date) => {
    const countDownDate = new Date(targetDate).getTime();

    const [countDown, setCountDown] = useState(countDownDate - new Date().getTime());

    useEffect(() => {
        const interval = setInterval(() => {
            setCountDown(countDownDate - new Date().getTime());
        }, 1000);

        return () => clearInterval(interval);
    }, [countDownDate]);

    return getReturnValues(countDown);
};

const getReturnValues = (relativeCountDown: number): [boolean, boolean, number, string, string, string, string] => {
    const isDateInPast = relativeCountDown < 0;
    const isLessThanTwoMinutes = relativeCountDown < 1000 * 60 * 2;

    const countDown = Math.abs(relativeCountDown);

    const days = Math.floor(countDown / (1000 * 60 * 60 * 24));
    const hours = Math.floor((countDown % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((countDown % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((countDown % (1000 * 60)) / 1000);

    return [isDateInPast, isLessThanTwoMinutes, days, toString(hours), toString(days * 24 + hours), toString(minutes), toString(seconds)];
};

const toString = (data: number): string => data.toString().padStart(2, '0');

export { useCountdown };
